"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAINTENANCE_COPY = void 0;
exports.MAINTENANCE_COPY = {
    PAGE_HEADER: 'Down For Maintenance',
    // eslint-disable-next-line max-len
    PAGE_SUBTEXT_PARTIAL_1: 'Hold tight, we\'re doing some maintenance. We\'ll be back soon!  Please reach out to ',
    PAGE_SUBTEXT_PARTIAL_2: ' with any questions.'
};
//# sourceMappingURL=COPY.js.map